import { createContext, useContext } from 'react';

import { LoginJourneyContextType } from './types';

export const LoginJourneyContext = createContext<LoginJourneyContextType>({
  loginJourney: {} as LoginJourneyContextType['loginJourney'],
  amazonLoginJourney: {} as LoginJourneyContextType['amazonLoginJourney'],
});

export const useLoginJourneyContext = () => {
  const context = useContext(LoginJourneyContext);

  if (!context) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }

  return context;
};
